/**
 * 获取class元素
 *
 * @param {str}        必填
 * @param {str | dom}  必填  默认是传ID 如果flag是true 传的就是dom元素
 * @param {boolean}    选填  区分el传的是ID还是DOM           
 */
function getClass(clsName, el, flag) {
    let oParents;

    if (!flag && el) {
        oParents = document.getElementById(el);
    } else if (flag && el) {
        oParents = el
    } else {
        oParents = document
    }

    let boxArr = new Array();
    let oElements = oParents.getElementsByTagName('*');
    for (let i = 0; i < oElements.length; i++) {
        let classNameArr = oElements[i].className.split && oElements[i].className.split(/\s+/) || [];

        for (let j = 0; j < classNameArr.length; j++) {
            if (classNameArr[j] === clsName) {
                boxArr.push(oElements[i]);
            }
        }

    }
    return boxArr;

}

/**
 * 自动设置表格高度
 *
 * @param {number} index 是否是多个表格
 */
const autoHeight = function (index) {

    // 需要持续优化 例如注释 变量名 增加默认默认对象参数 可接收对象
    index = index || 0;
    setTimeout(function () {
        let a = getClass('autoHeight', 'root')[index];

        let table = getClass('ant-table-body', a, true)[0];
        let tableInner = getClass('ant-table-body-inner', a, true)[0];

        // 没有设置class : autoHeight 返回
        if (!a) {
            return false;
        }
        let b = getClass('ant-table-wrapper', a, true)[0];
        // console.log('000000000000', {
        //     a
        // }, {
        //     b
        // });

        let t = a.offsetTop;
        let h = a.offsetHeight + a.offsetTop;
        // let h = a.offsetTop;
        let bodyHeight = document.body.clientHeight;
        let tableHeight = bodyHeight - t - 70;

        if (bodyHeight < h) {
            return false;
        }
        // console.log('bodyHeight=', bodyHeight, "h", h);

        table.style.maxHeight = tableHeight - 48 + 'px';
        tableInner.style.maxHeight = tableHeight - 48 + 'px';
        // console.log(table.style.maxHeight, 'tableHeight', tableHeight - 42);
        b.style.height = tableHeight - 5 + 'px';


    }, 100);
}


// 高度自动对齐
const alignmentHeight = function (itself, target) {

    // 需要持续优化 例如注释 变量名 增加默认默认对象参数 可接收对象

    setTimeout(function () {
        itself = getClass(itself, 'root')[0];

        target = getClass(target, 'root')[0];

        // if (!itself) {
        //     return false;
        // }


        let tableWrapper = getClass('ant-table-wrapper', itself, true)[0];

        let table = getClass('ant-table-body', itself, true)[0];
        let tableInner = getClass('ant-table-body-inner', itself, true)[0];

        // itself.style.height = target.offsetHeight + 'px';



        let tableHeight = tableWrapper.offsetHeight + (target.offsetHeight - itself.offsetHeight);
        // console.log(itself.offsetHeight, 'ffffffffff', target.offsetHeight);
        table.style.maxHeight = tableHeight * 0.84 + 'px';
        tableInner.style.maxHeight = tableHeight * 0.84 + 25 + 'px';

        tableWrapper.style.height = tableHeight + 'px';


    }, 200);
}

/**
 * 动态更改meta
 *
 * @param {str}   pathnames     必填          
 */
function changeMeta(pathnames) {
console.log(pathnames,'path')
    var x = document.getElementById("Solutionid")
    if (pathnames.indexOf('Solution') === 1) {
        x && x.remove(x[0])
        let oMeta = document.createElement('meta');
        oMeta.charset = 'utf-8';
        oMeta.name = "viewport";
        oMeta.id = "Solutionid";
        oMeta.content = "width=device-width, initial-scale=1, user-scalable=yes";
        document.getElementsByTagName('head')[0].appendChild(oMeta);
        console.log('11111')
    } else {
        x && x.remove(x[0])
        let oMeta = document.createElement('meta');
        oMeta.charset = 'utf-8';
        oMeta.name = "viewport";
        oMeta.id = "Solutionid";
        oMeta.content = "width=device-width, initial-scale=1, user-scalable=no";
        document.getElementsByTagName('head')[0].appendChild(oMeta);
        console.log('22222')
    }
}


function IsPC() {
    var userAgentInfo = navigator.userAgent;
    var Agents = ["Android", "iPhone",
                "SymbianOS", "Windows Phone",
                "iPad", "iPod"];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}


export { autoHeight, alignmentHeight, changeMeta, IsPC }


// WEBPACK FOOTER //
// ./src/common/Method.js